import {ExamQuestions, ListExam} from "models/managerTest";
import React, {useState, useEffect} from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Theme, createStyles, makeStyles} from "@material-ui/core/styles";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Slide,
} from "@material-ui/core";
import {dateTimeToFormatYYYYHHMM} from "utils/dateTimeFormat";
import {useTranslation} from "react-i18next";
import CloseIcon from "@material-ui/icons/Close";
import {toast} from "react-toastify";
import {deduplicateQuestions} from "utils/examPreview";
import managerTestApi from "api/managerTest";

export interface PickOldExamProps {
  data: ListExam[];
  setCreateQuestion: (e: any) => void;
  listQuestionsAdded: any;
  setListQuestionsAdded: (e: any) => void;
  setIsPickOldExam: (e: any) => void;
  setIsShowMainExam: (e: any) => void;
  setInitialRandomCount: (value: number | undefined) => void;
  valueForm?: any;
  setValueForm?: (e: any) => void;
}

export default function PickOldExamComponent({
  data,
  setCreateQuestion,
  setListQuestionsAdded,
  listQuestionsAdded,
  setIsPickOldExam,
  setIsShowMainExam,
  setInitialRandomCount,
}: PickOldExamProps) {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        width: "100%",
      },
      heading: {
        fontSize: theme.typography.pxToRem(15),
      },
      title: {
        fontSize: 16,
        fontWeight: "bold",
        marginBottom: 10,
      },
      question: {
        backgroundColor: "#fff",
        boxShadow: "0px 2px 4px rgba(168, 168, 168, 0.25), 0px 0px 4px rgba(168, 168, 168, 0.25)",
        borderRadius: 6,
        padding: "20px 40px",
        position: "relative",
      },
      question__content: {
        color: "#0065A6",
        fontSize: 15,
        marginLeft: 5,
      },
      checkbox: {
        color: "#DADADA",
        borderRadius: 5,
        position: "absolute",
        right: -1,
        top: 10,
      },
      checkAll: {
        position: "absolute",
        top: -13,
        right: 82,
        zIndex: 9999,
      },
      checkbox_all: {
        color: "#DADADA",
        borderRadius: 5,
      },
      btn_create: {
        background: "linear-gradient(360deg, #399BD9 0%, #83CFFF 172.67%)",
        color: "#fff",
        borderRadius: 20,
        padding: "10px 15px",
      },
      btn_goBack: {
        borderRadius: 20,
        color: "#fff",
        marginRight: 15,
        background: "linear-gradient(0deg, #FD5468 0%, rgba(255, 193, 200, 0.9) 169.32%)",
        padding: "10px 15px",
      },
      root_modal: {
        width: "100%",
        height: "60%",
        display: "flex",
        justifyContent: "center",
      },
      modal__container: {
        width: "100%",
        maxWidth: 450,
        borderRadius: 12,
        backgroundColor: "#fff",
        zIndex: 9,
        display: "flex",
        flexDirection: "column",
        margin: "30px 0",
        height: 230,
      },
      modal__header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 24px",
        minHeight: 65,
        borderBottom: "1px solid rgb(235, 235, 235)",
        "& >h6": {
          fontWeight: 700,
          fontSize: 18,
          marginLeft: 20,
        },
      },
      modal_content: {
        padding: "15px 30px",
      },
      input_confirm_question: {
        border: "none",
        borderBottom: "1px dashed #999",
        width: "30px",
        "&:focus": {
          border: "none",
          borderBottom: "1px dashed #999",
          outline: "none",
        },
        "&:focus-visible": {
          border: "none",
          borderBottom: "1px dashed #999",
          outline: "none",
        },
      },
    })
  );
  const classes = useStyles();
  const {t} = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [valueModalConfirm, setValueModalConfirm] = useState("");
  const [valueInputConfirm, setValueInputConfirm] = useState<any>("");

  const uniqueSelectedQuestions = deduplicateQuestions(listQuestionsAdded);
  const uniqueSelectedCount = uniqueSelectedQuestions.length;
  const getUniqueCount = (questions: ExamQuestions[]) =>
    deduplicateQuestions(questions as any[]).length;
  const handleClose = () => {
    setOpenModal(false);
  };
  const getItemKey = (q: any) => (q?.id ? `id:${q.id}` : `exam:${q?.examId}-q:${q?.questionId || q?.question?.id}`);
  const getQuestionContentKey = (q: any) => {
    const raw = q?.question?.content ?? q?.questionContent ?? q?.content ?? "";
    return raw ? raw.trim().toLowerCase().replace(/\s+/g, " ") : `id:${q?.questionId || q?.id}`;
  };

  const handleAddQuestion = (question: ExamQuestions) => {
    const key = getItemKey(question);
    const findItemIndex = listQuestionsAdded.findIndex((x: any) => getItemKey(x) === key);
    if (findItemIndex < 0) {
      setListQuestionsAdded([...listQuestionsAdded, { ...question }]);
    } else {
      const newListAdded = listQuestionsAdded.filter((item: any) => getItemKey(item) !== key);
      setListQuestionsAdded(newListAdded);
    }
  };

  const handleAddAllQuestion = (questions: ExamQuestions[], event: any) => {
    const checked = event.target.checked;
    if (!checked) {
      const keysToRemove = new Set((questions || []).map((q) => getItemKey(q)));
      const filterArray = listQuestionsAdded.filter((q: any) => !keysToRemove.has(getItemKey(q)));
      setListQuestionsAdded(filterArray);
    } else {
      const rawCount = (questions || []).length;
      const uniqueCount = getUniqueCount(questions);
      if (rawCount > uniqueCount) {
        toast.warning(
          `Đề gốc có ${rawCount - uniqueCount} câu trùng, chỉ chọn được ${uniqueCount}/${rawCount} câu hợp lệ`
        );
      }
      const existingKeys = new Set(listQuestionsAdded.map((q: any) => getItemKey(q)));
      const newQuestions = (questions || []).filter((q: any) => !existingKeys.has(getItemKey(q)));
      setListQuestionsAdded([...listQuestionsAdded, ...newQuestions]);
    }
  };

  function isChecked(array1: any, array2: any) {
    if (!array2 || array2.length === 0) return false;
    const set1 = new Set((array1 || []).map((item: any) => getItemKey(item)));
    return (array2 || []).every((element: any) => set1.has(getItemKey(element)));
  }

  const handleConfirmQuestion = () => {
    if (valueModalConfirm === "" && valueInputConfirm === 0) {
      toast.error("Vui lòng chọn một trong hai trường hợp");
      return;
    }
    if (valueModalConfirm === "2" && valueInputConfirm === 0) {
      toast.error("Vui lòng nhập số lượng câu hỏi muốn ngẫu nhiên");
      return;
    }

    if (valueModalConfirm === "2") {
      if (Number(valueInputConfirm) > uniqueSelectedCount) {
        toast.error(`Không đủ câu hỏi mẹ hợp lệ. Tối đa random ${uniqueSelectedCount} câu`);
        return;
      }
      setInitialRandomCount(Number(valueInputConfirm));
    } else {
      setInitialRandomCount(undefined);
    }
    setOpenModal(false);
    setCreateQuestion(true);
    setIsPickOldExam(false);
  };

  return (
    <Box style={{ paddingBottom: 80 }}>
      <Box style={{ flex: 1 }}>
        {listQuestionsAdded.length > 0 && (
          <Paper style={{ padding: "12px 20px", marginBottom: 16, backgroundColor: "#EBF3FA", borderRadius: 10, border: "1px solid #B8D8F0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 12 }}>
              <Typography variant="subtitle2" style={{ fontWeight: 700, color: "#004673", marginRight: 8 }}>
                {t("managerTest.thongkecauhoi")}:
              </Typography>
              <Chip label={`${t("managerTest.tongsocauhoigoc")}: ${listQuestionsAdded.length}`} style={{ backgroundColor: "#137BBD", color: "#fff", fontWeight: 600 }} size="small" />
              <Chip label={`${t("managerTest.socautrunglap")}: ${listQuestionsAdded.length - uniqueSelectedCount}`} style={{ backgroundColor: (listQuestionsAdded.length - uniqueSelectedCount) > 0 ? "#E53935" : "#757575", color: "#fff", fontWeight: 600 }} size="small" />
              <Chip label={`${t("managerTest.socauconlai")}: ${uniqueSelectedCount}`} style={{ backgroundColor: "#43A047", color: "#fff", fontWeight: 600 }} size="small" />
            </Box>
          </Paper>
        )}
        {data.map((item) => {
          return (
            <Box key={item.id} mb={2} position={"relative"}>
              <FormControl
                variant="outlined"
                margin="dense"
                size="small"
                className={classes.checkAll}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      className={classes.checkbox_all}
                      checked={isChecked(listQuestionsAdded, item.examQuestions || [])}
                      onChange={(event) => handleAddAllQuestion(item.examQuestions || [], event)}
                    />
                  }
                  label={"Chọn tất cả"}
                />
              </FormControl>
              <Accordion TransitionProps={{ timeout: 0 }} defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Box display="flex" width="100%">
                    <Box flexGrow={1} alignSelf={"center"}>
                      <Typography variant="h3" className={classes.title}>
                        {" "}
                        {item.examTitle}
                      </Typography>
                      <Typography variant="subtitle2">
                        <Typography
                          variant="subtitle1"
                          style={{fontWeight: 500, fontSize: 14, display: "inline"}}
                        >
                          Tổng câu
                        </Typography>
                        : {getUniqueCount(item.examQuestions || [])}/{(item.examQuestions || []).length}
                      </Typography>
                    </Box>
                    <Box width="50%" alignSelf={"center"}>
                      <Typography variant="h3" className={classes.title}>
                        {" "}
                        {dateTimeToFormatYYYYHHMM(item?.startDate)}
                      </Typography>
                      <Typography variant="subtitle2">
                        <Typography
                          variant="subtitle1"
                          style={{fontWeight: 500, fontSize: 14, display: "inline"}}
                        >
                          Tổng điểm
                        </Typography>
                        : <span style={{color: "#FD5468"}}>{item.totalPoint}</span> Điểm
                      </Typography>
                    </Box>
                    <Typography
                      variant="subtitle2"
                      style={{width: "5%", position: "absolute", right: 5, top: 6}}
                    >
                      {
                        listQuestionsAdded.filter((x: any) => (x.examId ?? x.exam?.id) === item.id).length
                      }
                      /{(item.examQuestions || []).length}
                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails style={{display: "block"}}>
                  <Divider style={{width: "80%", textAlign: "center"}} />
                  {(item.examQuestions || []).map((x: ExamQuestions, index: any) => (
                    <Box key={x.id}>
                      <Box mt={2} className={classes.question} key={index}>
                        <Box mb={1}>
                          <Box display="flex" justifyContent="space-between">
                            <Box display="flex" alignItems={"center"}>
                              <Checkbox
                                color="primary"
                                className={classes.checkbox}
                                checked={listQuestionsAdded.some((item: any) => getItemKey(item) === getItemKey(x))}
                                onChange={(event) => handleAddQuestion(x)}
                              />
                              <Typography variant="subtitle2" className={classes.question__content}>
                                {t("managerTest.cau")} {index + 1}:
                              </Typography>{" "}
                              <Typography variant="subtitle2" style={{fontSize: 15, marginLeft: 5}}>
                                {x.question?.content}
                              </Typography>
                            </Box>
                            <Typography variant="subtitle2">{x.question?.point} Điểm</Typography>
                          </Box>
                        </Box>
                        {x.question?.imageFileList?.length > 0 && (
                          <Box
                            display="grid"
                            gridTemplateColumns={
                              item?.imageFileIDList?.length === 1 ? "1fr" : "1fr 1fr"
                            }
                            gridGap={10}
                            my="10px"
                          >
                            {x.question?.imageFileList?.map((file: any) => {
                              return (
                                <img
                                  key={file.imageFileID}
                                  style={{
                                    width: "100%",
                                    height: "fit-content",
                                    maxHeight: "350px",
                                    borderRadius: "8px",
                                    objectFit: "contain",
                                  }}
                                  src={file?.imageFileURL}
                                  alt="img detail question"
                                />
                              );
                            })}
                          </Box>
                        )}
                        <Box>
                          {(x.question?.answersList || x.question?.answers || []).map((answer: any, index: any) => (
                            <Box key={answer?.id || index}>
                              {answer?.isRightAnswer ? (
                                <FormControlLabel
                                  control={
                                    <Radio
                                      color="primary"
                                      size="small"
                                      checked={answer?.isRightAnswer}
                                      style={{
                                        color: answer?.isRightAnswer ? "#43A047" : "#0065A6",
                                      }}
                                    />
                                  }
                                  label={
                                    <Typography
                                      variant="subtitle2"
                                      style={{fontWeight: answer?.isRightAnswer ? 700 : 500}}
                                    >
                                      {answer?.content}
                                    </Typography>
                                  }
                                />
                              ) : (
                                <FormControlLabel
                                  control={<Radio color="primary" size="small" />}
                                  label={
                                    <Typography
                                      variant="subtitle2"
                                      style={{fontWeight: answer?.isRightAnswer ? 700 : 500}}
                                    >
                                      {answer?.content}
                                    </Typography>
                                  }
                                />
                              )}
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </AccordionDetails>
              </Accordion>
            </Box>
          );
        })}
      </Box>
      <Box
        style={{
          position: "fixed",
          bottom: 0,
          right: 24,
          left: 280,
          backgroundColor: "#fff",
          padding: "12px 24px",
          boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.15)",
          zIndex: 1200,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          borderTop: "1px solid #E0E0E0",
        }}
      >
        <Button
          onClick={() => {
            setIsShowMainExam(true);
            setIsPickOldExam(false);
            setListQuestionsAdded([]);
          }}
          className={classes.btn_goBack}
        >
          {t("button.goback")}
        </Button>
        <Button
          className={classes.btn_create}
          onClick={() => {
            setOpenModal(true);
          }}
        >
          {t("button.next")}
        </Button>
      </Box>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        closeAfterTransition
        className={classes.root_modal}
      >
        <Slide direction="up" in={openModal}>
          <Box className={classes.modal__container}>
            <Box className={classes.modal__header}>
              <div></div>
              <Typography variant="subtitle2">Xác nhận số lượng câu hỏi</Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box className={classes.modal_content}>
              <RadioGroup
                name="oldExam"
                onChange={(event: any) => setValueModalConfirm(event.target.value)}
              >
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary" size="small" />}
                  label={
                    <Typography variant="subtitle2">
                      Tổng {uniqueSelectedCount}/{uniqueSelectedCount} câu
                    </Typography>
                  }
                />
                <FormControlLabel
                  value="2"
                  control={<Radio color="primary" size="small" />}
                  label={
                    <Typography variant="subtitle2">
                      Ngẫu nhiên{" "}
                      <input
                        className={classes.input_confirm_question}
                        type="number"
                        value={valueInputConfirm}
                        onChange={(e) => {
                          const rawValue = e.target.value;
                          if (rawValue === "") {
                            setValueInputConfirm("");
                            return;
                          }
                          const value = Number(rawValue);
                          if (value > uniqueSelectedCount) {
                            setValueInputConfirm(uniqueSelectedCount);
                          } else {
                            setValueInputConfirm(value);
                          }
                        }}
                      />{" "}
                      /{uniqueSelectedCount} câu
                    </Typography>
                  }
                />
              </RadioGroup>
              <Box textAlign={"center"} mt={2}>
                <Button
                  className={classes.btn_create}
                  style={{
                    padding: "5px 10px",
                    fontSize: 12,
                  }}
                  onClick={handleConfirmQuestion}
                >
                  Đồng ý
                </Button>
              </Box>
            </Box>
          </Box>
        </Slide>
      </Modal>
    </Box>
  );
}
